import { Reducer } from 'react';
import { Actions } from '../../actions/userList';
import { Action, UserListState } from '../../types';

const initialUserListState: UserListState = {
    searchPhrase: '',
};

const setSearchPhrase = (search: string, state: UserListState): UserListState => {
    return {
        ...state,
        searchPhrase: search,
    };
};

const userListReducer: Reducer<UserListState, Action> = (state, action): UserListState => {
    let newState = { ...state };

    switch (action.type) {
        case Actions.UPDATE_SEARCH_PHRASE:
            newState = setSearchPhrase(action.payload, state);
            break;
    }

    return newState;
};

export { initialUserListState, userListReducer };
